










































import { Component, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import WindowVue from "@/app/core/window/WindowVue";
import GameObjectManager from "@/app/basic/GameObjectManager";
import SocketFacade, {
  permissionCheck
} from "@/app/core/api/app-server/SocketFacade";
import { StoreUseData } from "@/@types/store";
import TaskManager from "@/app/core/task/TaskManager";
import { WindowOpenInfo } from "@/@types/window";
import VueEvent from "@/app/core/decorator/VueEvent";
import { DataReference } from "@/@types/data";
import LanguageManager from "@/LanguageManager";
import { ModeInfo } from "mode";
import { CardMeta, CardDeckBig, CardDeckSmall } from "@/@types/gameObject";
import CardDeckSetComponent, {
  DeckInfo
} from "@/app/basic/card/CardDeckSetComponent.vue";
import { createAddress } from "@/app/core/utility/CoordinateUtility";

@Component({
  components: {
    CardDeckSetComponent,
    CtrlButton
  }
})
export default class CardDeckListWindow extends Mixins<WindowVue<void, void>>(
  WindowVue
) {
  private isMounted: boolean = false;
  private cardMetaCC = SocketFacade.instance.cardMetaCC();
  private cardDeckBigCC = SocketFacade.instance.cardDeckBigCC();
  private cardDeckSmallCC = SocketFacade.instance.cardDeckSmallCC();
  private cardObjectCC = SocketFacade.instance.cardObjectCC();
  private mediaList = GameObjectManager.instance.mediaList;
  private cardMetaList = GameObjectManager.instance.cardMetaList;
  private cardObjectList = GameObjectManager.instance.cardObjectList;
  private cardDeckBigList = GameObjectManager.instance.cardDeckBigList;
  private selectedCardDeckBigId: string | null = null;
  private sceneLayerList = GameObjectManager.instance.sceneLayerList;

  @LifeCycle
  private async mounted() {
    await this.init();
    this.isMounted = true;
  }

  private get useCardDeckBigList() {
    return this.cardDeckBigList.filter(cd => permissionCheck(cd, "view"));
  }

  private get useCardMetaList() {
    return this.cardMetaList.filter(cm => permissionCheck(cm, "view"));
  }

  private get deckList(): DeckInfo[] {
    return this.useCardDeckBigList.map(cardDeckBig => {
      return {
        cardDeckBig,
        cardMetaList: this.useCardMetaList.filter(
          cm => cm.owner === cardDeckBig.id
        )
      };
    });
  }

  @VueEvent
  private getExclusionOwnerName(exclusionOwner: string) {
    const lockName = GameObjectManager.instance.getExclusionOwnerName(
      exclusionOwner
    );
    const editLabel = LanguageManager.instance.getText("label.editing");
    return `${lockName}(${editLabel})`;
  }

  @VueEvent
  private async preview() {
    if (!this.selectedCardDeckBigId) return;
    GameObjectManager.instance.roomData.sceneId = this.selectedCardDeckBigId;
    await TaskManager.instance.ignition<ModeInfo, never>({
      type: "mode-change",
      owner: "Quoridorn",
      value: {
        type: "view-card-deck",
        value: {
          flag: "on",
          cardDeckId: this.selectedCardDeckBigId
        }
      }
    });
  }

  @VueEvent
  private async addCardDeck() {
    await TaskManager.instance.ignition<ModeInfo, never>({
      type: "mode-change",
      owner: "Quoridorn",
      value: {
        type: "view-card-deck",
        value: {
          flag: "on",
          cardDeckId: ""
        }
      }
    });
  }

  @VueEvent
  private async editCardDeck() {
    if (!this.selectedCardDeckBigId) return;
    await this.close();
    await TaskManager.instance.ignition<WindowOpenInfo<string>, never>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "card-deck-edit-window",
        args: this.selectedCardDeckBigId
      }
    });
  }

  @VueEvent
  private async chmodCardDeck() {
    if (!this.selectedCardDeckBigId) return;
    await TaskManager.instance.ignition<WindowOpenInfo<DataReference>, never>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "chmod-window",
        args: {
          type: "card-deck",
          docId: this.selectedCardDeckBigId
        }
      }
    });
  }

  @VueEvent
  private async setDeck() {
    if (!this.selectedCardDeckBigId) return;
    const cardDeckSmallList: CardDeckSmall[] = [];
    const cardDeckBig = this.cardDeckBigList.filter(
      cdb => cdb.id === this.selectedCardDeckBigId
    )[0];
    const cardMetaList = this.cardMetaList.filter(
      cm => cm.owner === cardDeckBig.id
    );

    const cardDeckSmallId: string = (await this.cardDeckSmallCC.touch())[0];

    const cardObjectIdList = this.cardObjectList
      .filter(co => co.data!.cardDeckBigId === this.selectedCardDeckBigId)
      .map(co => co.id!);

    await this.cardObjectCC.touchModify(cardObjectIdList);
    await this.cardObjectCC.update(
      cardObjectIdList,
      cardObjectIdList.map(coId => {
        const co = this.cardObjectList.filter(co => co.id === coId)[0]!.data!;
        co.cardDeckSmallId = cardDeckSmallId;
        return co;
      })
    );

    const cardSceneLayer = this.sceneLayerList.filter(
      sl => sl.data!.type === "card"
    )[0];

    await this.cardDeckSmallCC.add(
      [cardDeckSmallId],
      [
        {
          address: createAddress(0, 0, 0, 0),
          layout: "deck",
          cardHeightRatio: 1,
          cardWidthRatio: 1,
          columns: 2,
          rows: 3,
          layoutColumns: 1,
          layoutRows: 1,
          name: "",
          tileReorderingMode: "insert",
          width: 200,
          layerId: cardSceneLayer.id!
        }
      ]
    );
  }

  @VueEvent
  private async deleteCardDeck() {
    if (!this.selectedCardDeckBigId) return;
    const result = window.confirm(
      LanguageManager.instance.getText("label.really-delete")
    );
    if (!result) return;
    try {
      await this.cardDeckBigCC.touchModify([this.selectedCardDeckBigId]);
    } catch (err) {
      // TODO show message.
      return;
    }
    await this.cardDeckBigCC.delete([this.selectedCardDeckBigId]);
  }
}
